module.exports = __webpack_public_path__ + "img/mata-atlantica.3274fd2d.png";